export const isLocalDev =
  window.location.hostname.startsWith("localhost") ||
  window.location.hostname.startsWith("bootstrap.qa") ||
  window.location.hostname.startsWith("bootstrap.sandbox");

export function entityHostParam(url) {
  return url && isLocalDev
    ? "?entity_host=" + (url.startsWith("//") ? url.slice(2) : url)
    : "";
}

export function entityHostUrl(entity, path) {
  const host = isLocalDev ? window.location.origin : "https:" + entity?.url;
  return `${host}${path}${entityHostParam(entity?.url)}`;
}
